import React from 'react';

function PrivacyPolicy() {
  return (
    <>
      <section className="py-20 relative overflow-hidden" id="privacy-policy">
        <div className="absolute bottom-0 right-0 -z-10 w-96 h-96 bg-up247-50 rounded-full filter blur-3xl opacity-30"></div>
        <div className="max-w-7xl mx-auto px-6 md:px-8">
          <h1 className="text-up247-800 font-bold">Privacy Policy</h1>
          <div className="privacy-policy-content">
            <p className="pl-4">
              At up247, we value your privacy and are committed to protecting your personal information. 
              This Privacy Policy outlines how we collect, use, and safeguard your data while using our services.
            </p>
            <br/>
            <h2 className="text-up247-800 font-bold">Information We Collect</h2>
            <p className="pl-4">
              We collect information that you provide directly to us, including name, email address, 
              and any other information you choose to provide when using our services.
            </p>
            <br/>
            <h2 className="text-up247-800 font-bold">How We Use Your Information</h2>
            <p className="pl-4">
              We use the information we collect to:
              <ul className="list-disc pl-8 space-y-2">
                <li>Provide and maintain our services</li>
                <li>Respond to your requests and inquiries</li>
                <li>Send you important updates and notifications</li>
                <li>Improve our services and user experience</li>
              </ul>
            </p>
            <br/>
            <h2 className="text-up247-700 font-bold">Data Security</h2>
            <p className="pl-4">
              We implement appropriate security measures to protect your personal information 
              from unauthorized access, alteration, or disclosure.
            </p>
            <br/>
            <p>
              For more details or questions about our privacy practices, please contact us at support@up247.org.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;
